import { runtimeConfig } from './runtime';

export const config = {
  service: {
    get name() {
      return runtimeConfig.service.name;
    },
    get version() {
      return runtimeConfig.service.version;
    },
  },

  get environment() {
    return runtimeConfig.environment;
  },

  get isProduction() {
    return /prod/i.test(runtimeConfig.environment);
  },

  get isDevelopment() {
    return /dev/i.test(runtimeConfig.environment);
  },

  get isStaging() {
    return /stag/i.test(runtimeConfig.environment);
  },

  get isEphemeral() {
    return /ephe/i.test(runtimeConfig.environment);
  },

  openTelemetry: {
    get enabled() {
      return runtimeConfig.openTelemetry.enabled;
    },
    get collector() {
      return runtimeConfig.openTelemetry.collector;
    },
  },

  pageSize: 25,

  posthog: {
    get enabled() {
      return runtimeConfig.posthog.enabled;
    },
    get key() {
      return runtimeConfig.posthog.key;
    },
    get host() {
      return runtimeConfig.posthog.host;
    },
    options: {
      autocapture: false,
      capture_pageview: true,
      capture_pageleave: true,
      persistence: 'localStorage' as const,
      disable_session_recording: true,
      disable_error_reporting: true,
    },
  },

  api: {
    get url() {
      return runtimeConfig.api.url;
    },
  },

  websocket: {
    get url() {
      return runtimeConfig.websocket.url;
    },
  },

  workOs: {
    get clientId() {
      return runtimeConfig.workOs.clientId;
    },
  },

  here: {
    get apiKey() {
      return runtimeConfig.here.apiKey;
    },
  },

  protomaps: {
    get apiKey() {
      return runtimeConfig.protomaps.apiKey;
    },
  },

  office: {
    wopi: {
      get baseUrl() {
        return runtimeConfig.office.wopi.baseUrl;
      },
    },
    collabora: {
      get baseUrl() {
        return runtimeConfig.office.collabora.baseUrl;
      },
    },
  },

  talkJs: {
    get appId() {
      return runtimeConfig.talkJs.appId;
    },
  },

  semaphor: {
    get embedUrl() {
      return runtimeConfig.semaphor.embedUrl;
    },
  },
} as const;
